import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=09fd6fcc&scoped=true"
import script from "./ColumnHeader.vue?vue&type=script&lang=ts"
export * from "./ColumnHeader.vue?vue&type=script&lang=ts"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&id=09fd6fcc&prod&scoped=true&lang=css"
import style1 from "./ColumnHeader.vue?vue&type=style&index=1&id=09fd6fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd6fcc",
  null
  
)

export default component.exports